import React from 'react';

import * as Analytics from 'analytics/Analytics';
import {AnalyticsMetadataForContext} from 'analytics/AnalyticsTypes';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import {CICOItemIdsToAssignee, SampleStatusItem} from 'constants/SampleStatusConstants';
import BaseCheckOutModal from 'inventory/check-in-check-out/BaseCheckOutModal';

interface Props {
  items: Array<SampleStatusItem>;
  onRequestClose: () => void;
  onReserve: (itemIdsToAssignee: CICOItemIdsToAssignee, comment?: string) => void;
  analyticsMetadata?: AnalyticsMetadataForContext;
  shouldAlwaysShowSampleStatusTable?: boolean;
}

export default function ReserveModal(props: Props): JSX.Element {
  return (
    <BaseCheckOutModal
      items={props.items}
      onCheckOut={props.onReserve}
      onRequestClose={props.onRequestClose}
      shouldWarnIfReservedForCurrentUser={true}
      title="Reserve"
      statusWarningTrackingParams={{
        actionOrigin: props.analyticsMetadata?.actionOrigin ?? ActionOrigin.UI_UNDETERMINED,
        actionAttempted: 'reserve',
        eventGroupId: props.analyticsMetadata?.eventGroupId ?? Analytics.makeAnalyticsEventId(),
      }}
      analyticsMetadata={{...props.analyticsMetadata, modalType: 'reserve'}}
      shouldAlwaysShowSampleStatusTable={props.shouldAlwaysShowSampleStatusTable}
    />
  );
}
